import { render, staticRenderFns } from "./benefitDialog.vue?vue&type=template&id=07fe4952&scoped=true&"
import script from "./benefitDialog.vue?vue&type=script&lang=js&"
export * from "./benefitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fe4952",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07fe4952')) {
      api.createRecord('07fe4952', component.options)
    } else {
      api.reload('07fe4952', component.options)
    }
    module.hot.accept("./benefitDialog.vue?vue&type=template&id=07fe4952&scoped=true&", function () {
      api.rerender('07fe4952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/expenses/expenses/dialog/benefitDialog.vue"
export default component.exports